import React from 'react'
import styled from '@emotion/styled'

const Form = styled.form`
`

export default Form